import { useState } from "react";
import { Link } from "react-router-dom";
import { Search, PlayCircle, Lock } from "lucide-react";
import { useDash, courseProgress } from "@/components/dashboard/Layout";
import { PageHead, Locked } from "@/components/dashboard/kit";

export default function MyCourses() {
  const { courses, progress, approved } = useDash();
  const [q, setQ] = useState("");
  const list = courses.filter((c) => c.title.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="my-courses-page">
      <PageHead title="My" highlight="Courses" sub="Courses included in your package." />
      {!courses.length ? <Locked text="No package is linked to your ID yet." /> : (
        <>
          <label className="glass rounded-full px-5 py-3 flex items-center gap-3 mb-6"><Search size={17} className="text-[var(--muted)]" /><input data-testid="course-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search your courses" className="bg-transparent outline-none flex-1 text-sm" /></label>
          <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-5">
            {list.map((c) => {
              const p = courseProgress(progress, c);
              const Inner = (
                <div className="glass neon-card rounded-3xl overflow-hidden h-full">
                  <div className="relative h-40"><img src={c.image} alt={c.title} className="w-full h-full object-cover" />
                    <span className="absolute top-3 right-3 glass rounded-full w-9 h-9 grid place-items-center text-[var(--pink)]">{approved ? <PlayCircle size={18} /> : <Lock size={16} />}</span></div>
                  <div className="p-5">
                    <h3 className="font-display text-lg font-semibold">{c.title}</h3>
                    <p className="text-xs text-[var(--muted)] mt-1">{p.done}/{p.total} lessons · {c.instructor}</p>
                    <div className="h-1.5 rounded-full bg-[var(--bg-2)] mt-3 overflow-hidden"><div className="h-full rounded-full" style={{ width: `${p.pct}%`, background: "var(--btn-bg)" }} /></div>
                  </div>
                </div>
              );
              return approved
                ? <Link key={c.slug} to={`/dashboard/courses/${c.slug}`} data-testid={`my-course-${c.slug}`}>{Inner}</Link>
                : <div key={c.slug} data-testid={`my-course-${c.slug}`} className="opacity-70 cursor-not-allowed">{Inner}</div>;
            })}
          </div>
          {!approved && <p className="text-xs text-[var(--muted)] mt-5">Lessons open after your ID is approved.</p>}
        </>
      )}
    </div>
  );
}
